{
	"add": "Ajouter produit",
	"price": "Prix de vente",
	"product": "Produit",
	"productInformation": "Information produit",
	"title": "Ajouter un produit au menu",
	"validateField": "Champs obligatoire"
}
